export default "<app-prescription-list-view [prescriptionIDs]=\"prescriptionIDs\"></app-prescription-list-view>\r\n";